"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CACabinetCertificate = exports.DSSAuthType = exports.SignatureAlgorithm = exports.RAReqFormState = exports.ProjectType = exports.CSPType = void 0;

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var constants_1 = require("../../utils/constants");

var CSPType;

(function (CSPType) {
  CSPType[CSPType["CryptoPro"] = 0] = "CryptoPro";
  CSPType[CSPType["VipNet"] = 1] = "VipNet";
  CSPType[CSPType["CryptographicToken"] = 2] = "CryptographicToken";
  CSPType[CSPType["DSS"] = 3] = "DSS";
  CSPType[CSPType["ASESS"] = 4] = "ASESS";
})(CSPType = exports.CSPType || (exports.CSPType = {}));

var ProjectType;

(function (ProjectType) {
  ProjectType[ProjectType["None"] = 0] = "None";
  ProjectType[ProjectType["Elba"] = 1] = "Elba";
  ProjectType[ProjectType["Evrika"] = 2] = "Evrika";
  ProjectType[ProjectType["Otchet"] = 3] = "Otchet";
  ProjectType[ProjectType["Kemb"] = 4] = "Kemb";
  ProjectType[ProjectType["KE"] = 5] = "KE";
  ProjectType[ProjectType["Diadoc"] = 6] = "Diadoc";
  ProjectType[ProjectType["TaxReturn"] = 7] = "TaxReturn";
  ProjectType[ProjectType["AlcoDeclaration"] = 8] = "AlcoDeclaration";
  ProjectType[ProjectType["KonturFMS"] = 9] = "KonturFMS";
  ProjectType[ProjectType["Egais"] = 10] = "Egais";
  ProjectType[ProjectType["OFD"] = 11] = "OFD";
  ProjectType[ProjectType["Market"] = 12] = "Market";
  ProjectType[ProjectType["AltaGTD"] = 13] = "AltaGTD";
  ProjectType[ProjectType["AutoIon"] = 14] = "AutoIon";
  ProjectType[ProjectType["MagnitNPF"] = 15] = "MagnitNPF";
  ProjectType[ProjectType["DomClick"] = 16] = "DomClick";
  ProjectType[ProjectType["Rusagro"] = 17] = "Rusagro";
  ProjectType[ProjectType["Evraz"] = 18] = "Evraz";
  ProjectType[ProjectType["Vmassive"] = 19] = "Vmassive";
})(ProjectType = exports.ProjectType || (exports.ProjectType = {}));

var RAReqFormState;

(function (RAReqFormState) {
  RAReqFormState[RAReqFormState["NotEligible"] = 0] = "NotEligible";
  RAReqFormState[RAReqFormState["New"] = 2] = "New";
  RAReqFormState[RAReqFormState["NewInRC"] = 3] = "NewInRC";
  RAReqFormState[RAReqFormState["Validating"] = 4] = "Validating";
  RAReqFormState[RAReqFormState["Validated"] = 5] = "Validated";
  RAReqFormState[RAReqFormState["ReadyForRequestGeneration"] = 6] = "ReadyForRequestGeneration";
  RAReqFormState[RAReqFormState["Releasing"] = 7] = "Releasing";
  RAReqFormState[RAReqFormState["ReadyToInstall"] = 8] = "ReadyToInstall";
  RAReqFormState[RAReqFormState["CertificateInstalled"] = 9] = "CertificateInstalled";
  RAReqFormState[RAReqFormState["ErrorInRC"] = 10] = "ErrorInRC";
  RAReqFormState[RAReqFormState["Error"] = 11] = "Error";
  RAReqFormState[RAReqFormState["Released"] = 12] = "Released";
  RAReqFormState[RAReqFormState["PreValidating"] = 13] = "PreValidating";
  RAReqFormState[RAReqFormState["ReleaseExpired"] = 14] = "ReleaseExpired";
})(RAReqFormState = exports.RAReqFormState || (exports.RAReqFormState = {}));

var SignatureAlgorithm;

(function (SignatureAlgorithm) {
  SignatureAlgorithm[SignatureAlgorithm["GOST2001"] = 0] = "GOST2001";
  SignatureAlgorithm[SignatureAlgorithm["GOST2012"] = 1] = "GOST2012";
})(SignatureAlgorithm = exports.SignatureAlgorithm || (exports.SignatureAlgorithm = {}));

var DSSAuthType;

(function (DSSAuthType) {
  DSSAuthType[DSSAuthType["None"] = 0] = "None";
  DSSAuthType[DSSAuthType["IdOnly"] = 1] = "IdOnly";
  DSSAuthType[DSSAuthType["SimAuth"] = 2] = "SimAuth";
  DSSAuthType[DSSAuthType["MobileAuth"] = 3] = "MobileAuth";
  DSSAuthType[DSSAuthType["SmsAuth"] = 4] = "SmsAuth";
})(DSSAuthType = exports.DSSAuthType || (exports.DSSAuthType = {}));

var CACabinetCertificate =
/** @class */
function () {
  function CACabinetCertificate(rawCertificate) {
    var _this = this;

    this.rawCertificate = rawCertificate;

    this.type = function () {
      return _this.rawCertificate.CSPType === CSPType.DSS ? Plugin_1.CertificateType.Cloud : Plugin_1.CertificateType.Iron;
    };

    this.thumbprint = function () {
      var _a;

      return ((_a = _this.rawCertificate.Thumbprint) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || _this.rawCertificate.Id;
    };

    this.inn = function () {
      return _this.rawCertificate.Inn;
    };

    this.kpp = function () {
      return _this.rawCertificate.Kpp;
    };

    this.issuer = function () {
      return constants_1.TRUSTED_ISSUER;
    };

    this.owner = function () {
      var Fio = _this.rawCertificate.Fio;
      return Fio.LastName + " " + Fio.FirstName + " " + Fio.MiddleName;
    };

    this.organizationName = function () {
      return _this.rawCertificate.Organization;
    };

    this.validTo = function () {
      return _this.rawCertificate.CertificateValidTo ? new Date(_this.rawCertificate.CertificateValidTo) : new Date();
    };

    this.validFrom = function () {
      return _this.rawCertificate.CertificateValidFrom ? new Date(_this.rawCertificate.CertificateValidFrom) : new Date();
    };

    this.serialNumber = function () {
      return '';
    };

    this.hasPrivateKey = function () {
      return false;
    };

    this.isQualified = function () {
      return true;
    };

    this.isCloud = function () {
      return _this.rawCertificate.CSPType === CSPType.DSS;
    };

    this.cryptoProvider = function () {
      return undefined;
    };

    this.containerInfo = function () {
      return undefined;
    };

    this.publicKeyLength = function () {
      return undefined;
    };

    this.publicKeyAlgorithm = function () {
      return _this.rawCertificate.SignatureAlgorithm === SignatureAlgorithm.GOST2012 ? Plugin_1.PublicKeyAlgorithm.GOSTR3410_2012_256 : Plugin_1.PublicKeyAlgorithm.GOSTR410_2001;
    };

    this.licenseBuiltin = function () {
      return false;
    };

    this.ogrn = function () {
      return '';
    };

    this.toBase64 = function () {
      return '';
    };

    this.raw = function () {
      return _this.rawCertificate;
    };

    this.extensions = function () {
      return {};
    };

    this.title = function () {
      return '';
    };

    this.subjectType = function () {
      return '';
    };
  }

  return CACabinetCertificate;
}();

exports.CACabinetCertificate = CACabinetCertificate;